import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import s from './TextShortener.less'
import { truncate } from '../../utils/string'
import { selectCurrentHistoryFullRoute } from '../../store/history/history.selectors'

const DEFAULT_MAX_CHAR = 150
const DEFAULT_EXPAND_BUTTON_LABEL = 'En savoir plus'

const TextShortener = ({ text, expandButtonLabel = DEFAULT_EXPAND_BUTTON_LABEL, maxChar = DEFAULT_MAX_CHAR }) => {
  const [short, setShort] = useState(__BROWSER__)

  useShortenOnRouteChange(setShort)

  if (!text) return <></>

  const needShortening = text.length > maxChar

  return (
    <div onClick={() => needShortening && setShort(false)}>
      <span>{short ? truncate(maxChar)(text) : text}</span>
      {short && needShortening && <span className={s.more}>{expandButtonLabel}</span>}
    </div>
  )
}

const useShortenOnRouteChange = setShort => {
  const fullRoute = useSelector(selectCurrentHistoryFullRoute)

  useEffect(() => setShort(true), [fullRoute, setShort])
}

TextShortener.propTypes = {
  text: PropTypes.string,
  expandButtonLabel: PropTypes.string,
  maxChar: PropTypes.number
}

export default TextShortener
